import React from "react";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import {injectIntl} from "react-intl";

const toEditorState = (html) => {
  if (html === "" || !html) {
    const contentState = ContentState.createFromText("")
    return EditorState.createWithContent(contentState);
  } else {
    var blocksFromHTML;
    var contentBlocks;
    try {
      blocksFromHTML = htmlToDraft(html);
      contentBlocks = blocksFromHTML.contentBlocks;
    } catch(e) {
      blocksFromHTML = convertFromHTML(html);
      contentBlocks = blocksFromHTML.contentBlocks;
    }
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    return EditorState.createWithContent(contentState);
  }
}

const toHtml = editorState => {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
};

let toolbarConfig = {
  image: false
};

let editorStyle = {
  height: 400,
  padding: 10
};

let toolbarStyle = {
  width: "100%",
  padding: "10px 0",
  border: "none",
  borderBottom: "1px solid #efefef"
};

class QuestionNoteModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noteState: toEditorState(
        this.props.defaultValue || this.props.question.notesPrompt || ""
      )
    };
  }

  componentWillReceiveProps(nextProps) {
    const nextDefaultValue =
      nextProps.defaultValue || nextProps.question.notesPrompt || "";
    const oldDefaultValue =
      this.props.defaultValue || this.props.question.notesPrompt || "";
    if (nextDefaultValue !== oldDefaultValue) {
      this.setState({
        noteState: toEditorState(nextDefaultValue)
      });
    }
  }

  render() {
    let { open } = this.props;
    var intl = this.props.intl;
    const actions = [
      <FlatButton label={intl.formatMessage({ id:"general.cancel", defaultMessage:"Cancel" })} onClick={this.handleCancelClick} />,
      <RaisedButton
        label={intl.formatMessage({ id:"general.save", defaultMessage:"Save" })}
        primary={true}
        disabled={false}
        onClick={this.handleSave}
      />
    ];

    let qTitle = this.props.question.title;
    if(this.props.trQuestion){
      qTitle = this.props.trQuestion.title
    }

    return (
      <Dialog
        autoScrollBodyContent={true}
        modal={true}
        title={intl.formatMessage({ id:"general.notes", defaultMessage:"Notes" })}
        open={open}
        actions={actions}
      >
        <div style={{
          fontStyle: 'italic',
          marginBottom: 16,
          fontSize: 18,
          fontWeight: "500",
          color: "#404040"
        }}>{qTitle.replace(/<.*?>/gm, '')}</div>
        <Editor
          toolbar={toolbarConfig}
          editorStyle={editorStyle}
          toolbarStyle={toolbarStyle}
          editorState={this.state.noteState}
          onEditorStateChange={this.handleEditorStateChange}
        />
      </Dialog>
    );
  }

  handleSave = () => {
    var note = toHtml(this.state.noteState);
    if (note === "<p></p>" || note === "<p></p>\n") {
      note = "";
    }
    if (this.props.onSave) {
      this.props.onSave(note);
    }
    this.props.onRequestClose();
  };

  handleCancelClick = () => {
    this.props.onRequestClose();
  };

  handleEditorStateChange = v => {
    this.setState({ noteState: v });
  };
}

export default injectIntl(QuestionNoteModal);
